import { ReactNode, createContext, useContext } from "react";
import { useFilterRewardEvent } from "./filter-reward-event.hook";

const FilterRewardEventContext = createContext(
  {} as ReturnType<typeof useFilterRewardEvent>
);
export function useFilterRewardEventContext() {
  return useContext(FilterRewardEventContext);
}

interface FilterRewardEventProviderProps {
  children: ReactNode;
}
export function FilterRewardEventProvider({
  children,
}: FilterRewardEventProviderProps) {
  return (
    <FilterRewardEventContext.Provider value={useFilterRewardEvent()}>
      {children}
    </FilterRewardEventContext.Provider>
  );
}